import clsx from "clsx";
// icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHashtag } from "@fortawesome/pro-solid-svg-icons";
import Link from "next/link";
const baseStyles =
  "border-0 p-2 md:px-3 md:py-2 flex max-w-fit items-center gap-2 bg-white/80 text-txt-base text-xs rounded-xl font-bold leading-none whitespace-nowrap";

export function Tag({ children, className, ...props }) {
  return (
    <p className={clsx(className, baseStyles)} {...props}>
      <FontAwesomeIcon icon={faHashtag} className="text-sec" />
      {children}
    </p>
  );
}
